import jsPDF from 'jspdf';
import 'jspdf-autotable';

function generatePDF(assessmentData, hippaData){

    const complianceObject = JSON.parse(assessmentData)
    //Initialize JsPDF
    const doc = new jsPDF();
    //Define table columns
    const tableColumn = ["Question", "Response"];
    //Define Array for table rows
    var tableRows = [];

    //Generate table rows from Assessment data
    Object.keys(complianceObject).map((item) => {
        if(complianceObject[item].question === "{{hidden:tenantname}}'s Legal Name:"){
            complianceObject[item].question = "Company's Legal name:"
        }
        const complianceData = [
            complianceObject[item].question,
            complianceObject[item].response,
        ];
        tableRows.push(complianceData);
    });

    //Convert the HIPAA Assessment data from string to JSON
    var hippaObject = JSON.parse(hippaData)

    var data = hippaObject.split(',"')

    for (let i = 0; i<data.length; i++){
        var dataRow = data[i].split('":')
        if(dataRow[1] === 'true' || dataRow[1] === 'true}'){
            dataRow[1] = 'Yes'
        }else if(dataRow[1] === 'false' || dataRow[1] === 'false}'){
            dataRow[1] = 'No'
        }

        if(dataRow[0] === '{"Have all staff members undergone annual HIPAA training?') {
            dataRow[0] = 'Have all staff members undergone annual HIPAA training?'
        }

        if(dataRow[0] === 'score' ||  dataRow[0] === 'partitionKey' || dataRow[0] === 'sortKey'){
            dataRow[0] = null
            dataRow[1] = null
        }

        if(dataRow[0] === null){
            i++
        }else{
            const rowObject = [
                dataRow[0],
                dataRow[1],
            ];
            tableRows.push(rowObject);
        }
    }

    const date = Date().split(" ")
    const dateStr = date[0] + '-' + date[1] + '-' + date[2] + '-' + date[3]

    doc.autoTable(tableColumn, tableRows, {startly: 20});
    doc.save(complianceObject[12].response + '_Report_' + dateStr + '.pdf')
};

export default generatePDF;


// WEBPACK FOOTER //
// ./src/utils/reportGenerator.js